import { isEmpty } from 'lodash';
import type { Tab } from 'rc-tabs/lib/interface';
import type { DrillBlastRequestHistoryItem } from 'shared/api/workspace';
import { drillAndBlastTabs } from './constants';
import { DrillAndBlastGuide } from './drill-and-blast-guide';
import { DrillAndBlastGenerateForm } from './generate';
import {
  DrillAndBlastHistoryEmptyList,
  DrillAndBlastHistoryList,
} from './history';

type TabsProps = {
  onClickGenerateFromHistory: VoidFunction;
  historyItems?: DrillBlastRequestHistoryItem[];
};

export const DrillAndBlastTabs = ({
  onClickGenerateFromHistory,
  historyItems = [],
}: TabsProps): Tab[] => {
  return [
    {
      label: drillAndBlastTabs.Generate,
      key: drillAndBlastTabs.Generate,
      children: <DrillAndBlastGenerateForm />,
    },
    {
      label: drillAndBlastTabs.History,
      key: drillAndBlastTabs.History,
      children: (
        <div className="drill-and-blast__container__history drill-and-blast-tab-content">
          {!isEmpty(historyItems) ? (
            <DrillAndBlastHistoryList items={historyItems} />
          ) : (
            <DrillAndBlastHistoryEmptyList
              onClickGenerateFromHistory={onClickGenerateFromHistory}
            />
          )}
        </div>
      ),
    },
    {
      label: drillAndBlastTabs.Guide,
      key: drillAndBlastTabs.Guide,
      children: <DrillAndBlastGuide />,
    },
  ];
};
